import {makeAutoObservable} from "mobx";

class PinStore {


    sdCode = 0;
    sdPin = 0;
    constructor() {
        makeAutoObservable(this)
    }

    setPinCode(sdCode, sdPin) {
        this.sdCode = sdCode;
        this.sdPin = sdPin;
    }

    getPinCode() {
        return {
            sdCode: this.sdCode,
            sdPin: this.sdPin
        }
    }

}

let pinStore = new PinStore()
export default pinStore;